// extracted by mini-css-extract-plugin
export default {"container":"Image_container__CccmL","container-image":"Image_container-image__zPx1t"};